var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolButton',{class:{ 'toggled': _vm.Editor.isActive('bold') },attrs:{"Editor":_vm.Editor,"KnownIcon":"Bold"},on:{"ToolClick":function($event){_vm.Editor.chain().focus().toggleBold().run()}}})}
var staticRenderFns = []

export { render, staticRenderFns }